import * as React from "react";
import {inject} from "mobx-react";


import {ButtonInline} from "@ok/common/design-system/components/ButtonInline";
import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";
import { reduceNumber } from "@core-client/utils/numbers";
import classes from "../Clip.styl";
import {Clip, CLIP_URLS} from "../../../../lib/types";
import {AnonymControlWrapper} from "../../common/controls/AnonymControlWrapper";
import {DataL} from "@ok/web/utils/DataL";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface ILike {
    bean: Clip;
    store?: ClipsFullscreenStore
}

export const Like: React.FC<ILike> = inject("store")((props): React.ReactElement => {
    const store = props.store!;
    const likeInfo = props.bean.payload.likeInfo;
    const authorInfo = props.bean.payload.authorInfo;
    const clipId = props.bean.meta.movie.id;

    const [isLiked, setIsLiked] = React.useState(likeInfo.userLikeSet);
    const [isProc, setProc] = React.useState(false);

    React.useEffect(() => {
        if (isProc) {
            return;
        }

        setProc(true);

        const isLiked = store.tmpLikeHelper.getLike(Number(clipId));
        if (isLiked) {
            setIsLiked(isLiked);

            if (isLiked) {
                ++likeInfo.count;
            }
        }
    }, [store.tmpLikeHelper, clipId, likeInfo.count, isProc]);

    function handleLike() {
        if (store.isAnonym) {
            return;
        }

        if (isLiked) {
            store.doRequest(CLIP_URLS.UNLIKE);
            likeInfo.userLikeSet = false;
            setIsLiked(false);
            likeInfo.count = likeInfo.count > 0 ? likeInfo.count - 1 : 0;
            store.tmpLikeHelper.setLike(Number(clipId), false);
        } else {
            store.doRequest(CLIP_URLS.LIKE);

            likeInfo.userLikeSet = true;
            setIsLiked(true);

            ++likeInfo.count;
            store.tmpLikeHelper.setLike(Number(clipId), true);
        }
    }

    const logAttr = DataL.attr({
        target: "VK_CLIPS_LIST_LIKE",
        clipId: clipId,
        ownerId: authorInfo.id,
        position: store.currentItemIndex
    });

    return (
        <AnonymControlWrapper>
            <div className={classes["control__content"]} {...logAttr}>
                <ButtonInline
                    data-tsid={"clip-like-button"}
                    size={"32"}
                    view={"primary-on-color"}
                    aria-label={l10NPkg.getLMsg("setLikeOnClip")}
                    onClick={() => handleLike()}
                >
                    <ButtonInline.LeftIcon
                        icon={isLiked ? "glyph_klass_filled_24+" : "glyph_klass_24+"}
                    />
                </ButtonInline>
                {likeInfo.count > 0 && (
                    <span>{reduceNumber(likeInfo.count).formatted}</span>
                )}
            </div>
        </AnonymControlWrapper>
    );
});
